import actions from '../constants/actions'

const mergeTheme = (source, target) => {
    return {
        ...source,
        header: target.header,
        info: target.info,
        footer: target.footer,
        favicon: typeof target.favicon !== "undefined" && target.favicon !== null ? target.favicon : "/favicon.ico",
        completedScreen: target.completedScreen,
        classes: {
            ...source.classes,
            ...target.classes
        },
        text: {
            ...source.text,
            ...target.text
        }
    };
};

const common = (state = [], action) => {
    switch (action.type) {
        case actions.GET_THEME_SUCCESS:
            return {
                ...state,
                themeReady: true,
                theme: mergeTheme(state.theme, action.theme)
            }
        
        case actions.INJECT_THEME:
            return {
                ...state,
                themeReady: true,
                theme: mergeTheme(state.theme, action.theme),
                whitelabel: '',
                style: action.styles
            }
        case actions.SET_WL:
            return {
                ...state,
                whitelabel: action.whitelabel
            }
            
            
        default:
            return state
    }
}

export default common